import { Heading } from "@chakra-ui/react";
import React from "react";

interface GuideContentHeaderProps {
  title: string;
}

export default function GuideContentHeader({
  title,
}: GuideContentHeaderProps): React.ReactElement {
  return (
    <Heading size="xl" fontWeight="bold" color="gray.800">
      {title}
    </Heading>
  );
}
